import gql from 'graphql-tag';

export default gql`
query ($id: String!, $version: Int!) {
  getCampaign (id: $id, version: $version) {
    __typename
    id
    version 
    name
    advertiserId
    advertiser {
      name
      costModifier
      brands
    }
    startDate
    endDate
    brand
    layers {
      __typename
      id
      name
      websites {
        id
        name
      }
    }
    budgetLines {
      __typename
      id
      campaignId
      layerId
      buyType
      websiteId
      purchaseModelId
      format
      details
      costModifier
      comments
      flights {
        __typename
        id
        startDate
        endDate
        budget
        unitCost
        estimatedUnits
      }
      externalMaps {
        __typename
        providerId
        externalId
        budgetLineId
        flightId
        externalField
      }
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/GetQuery.js